import css from './GrandTotalSelectedFooter.module.css';
import { ReactNode, useState } from 'react';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import ThinArrowIcon from '@shared/Icons/ThinArrowIcon';
import { FormatNumber } from '@shared/Helpers/FormatValue/FormatNumber/FormatNumber';
import { CustomProjectStep2ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep2ElementsIdsEnum';
import React from 'react';
import classNames from 'classnames';

interface GrandTotalSelectedFooterProps {
    children?: ReactNode;
    grandTotal?: number;
    toolsTotal?: number;
    materialsTotal?: number;
    laboursTotal?: number;

    runTour?: boolean;
}

const GrandTotalSelectedFooter: React.FC<GrandTotalSelectedFooterProps> = ({
    children,
    grandTotal,
    toolsTotal,
    materialsTotal,
    runTour,
    laboursTotal,
}) => {
    const [isTotalFooterExpanded, setIsTotalFooterExpanded] =
        useState(!runTour);
    const handleShowTotalFooter = () => {
        if (!runTour) {
            setIsTotalFooterExpanded(prev => !prev);
        }
    };

    const [isDesktop] = useMediaType();

    return (
        <div
            className={`${css.footerContainer} ${isTotalFooterExpanded ? css.expanded : ''}`}
        >
            {isDesktop && (
                <BasicButton
                    id={
                        CustomProjectStep2ElementsIdsEnum.STEP2_PAGE_EXPAND_BUTTON
                    }
                    onClick={handleShowTotalFooter}
                    children={
                        <>
                            <ThinArrowIcon
                                className={classNames(
                                    { [css.closed]: !isTotalFooterExpanded },
                                    css.iconSvg
                                )}
                                stroke="currentColor"
                            />
                            {isTotalFooterExpanded ? 'Hide' : 'Show'}
                        </>
                    }
                    extraClassName={`${css.showTotalFooterBtn} ${isTotalFooterExpanded ? css.reverse : ''}`}
                />
            )}

            <div
                className={classNames(
                    css.footer,
                    { [css.footerExpanded]: isTotalFooterExpanded },
                    { [css.userGuide]: runTour }
                )}
            >
                <div>Grand total selected:</div>

                <div className={css.footerList}>
                    <div className={css.listItem}>
                        <span>Tools:</span>
                        <span className={css.dashedLine}></span>
                        <span className={css.price}>
                            R {FormatNumber(toolsTotal, '0.00')}
                        </span>
                    </div>

                    <div className={css.listItem}>
                        <span>Labour:</span>
                        <span className={css.dashedLine}></span>
                        <span className={css.price}>
                            R {FormatNumber(laboursTotal, '0.00')}
                        </span>
                    </div>

                    <div className={css.listItem}>
                        <span>Material:</span>
                        <span className={css.dashedLine}></span>
                        <span className={css.price}>
                            R {FormatNumber(materialsTotal, '0.00')}
                        </span>
                    </div>

                    <div className={css.listItem}>
                        <span>Grand total:</span>
                        <span className={css.dashedLine}></span>
                        <span className={css.totalPrice}>
                            R {FormatNumber(grandTotal, '0.00')}
                        </span>
                    </div>
                </div>
            </div>
            <div className={css.btns}>{children}</div>
        </div>
    );
};

export default React.memo(GrandTotalSelectedFooter);
